import React from 'react';
import { Paper, Box, FormLabel, Divider, List, ListItem, Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import TodayIcon from '@material-ui/icons/Today';
import DateFnsUtils from '@date-io/date-fns';
import clsx from 'clsx';
import classes from './TableFilter.module.scss';
import Filter from '../Filter';

const TableFilter = ({ children }) => {
  return <Paper className={classes.tableFilter}>{children}</Paper>;
};

const FilterDate = ({ ...props }) => {
  const options = [
    {
      label: 'All time',
      key: 'all_time',
    },
    {
      label: 'This month',
      key: 'this_month',
    },
    {
      label: 'Next month',
      key: 'next_month',
    },
    {
      label: 'Next 3 months',
      key: 'next_three_months',
    },
  ];
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Box className={classes.content__date}>
        <section>
          <Box>
            <FormLabel component='legend'>From</FormLabel>
            <DatePicker
              variant='inline'
              disableToolbar
              inputVariant='outlined'
              value={new Date()}
              format='dd/MM/yyyy'
              onChange={(newDate) => {}}
              InputProps={{
                startAdornment: (
                  <Box className={classes.iconContainer}>
                    <TodayIcon />
                  </Box>
                ),
              }}
            />
          </Box>
          <Divider orientation='horizontal' />
          <Box>
            <FormLabel component='legend'>To</FormLabel>
            <DatePicker
              variant='inline'
              disableToolbar
              inputVariant='outlined'
              value={new Date()}
              format='dd/MM/yyyy'
              onChange={(newDate) => {}}
              InputProps={{
                startAdornment: (
                  <Box className={classes.iconContainer}>
                    <TodayIcon />
                  </Box>
                ),
              }}
            />
          </Box>
        </section>
        <List className={classes.list}>
          {options.map(({ key, label }) => (
            <ListItem key={key}>
              <Button variant='outlined'>{label}</Button>
            </ListItem>
          ))}
        </List>
      </Box>
    </MuiPickersUtilsProvider>
  );
};

const DefaultFilter = ({ className, ...props }) => {
  return <Filter containerClasses={clsx(classes.content__default, className)} {...props} />;
};

TableFilter.Date = FilterDate;
TableFilter.DefaultFilter = DefaultFilter;

export default TableFilter;
